import { jsx as _jsx } from "react/jsx-runtime";
import Sketch from '@uiw/react-color-sketch';
/**
 * Preset colors based on Lucy brand palette
 */
const PRESET_COLORS = [
    '#2aa3f9', // canvasBlue
    '#FCCD27', // canvasYellow
    '#ED3083', // canvasRed
    '#7DFA48', // canvasGreen
    '#409c19', // canvasGreenDark
    '#f58220', // spaceworxOrange
    '#4d4d4d', // canvasGray
    '#FFFFFF', // white
    '#000000', // black
    '#5752c9', // pc-1
    '#c952c9', // pc-2
    '#52c4c9', // pc-4
];
/**
 *
 * @export
 * Color pallet - wrapper for @uiw/react-color-sketch
 */
const ColorPallet = (props) => {
    const { color, onChange } = props;
    return (_jsx("div", { className: 'uxpcore_colorpicker__palette-container', children: _jsx(Sketch, { color: color, onChange: (newColor) => {
                // Convert to rgba string format
                const { r, g, b, a } = newColor.rgba;
                const colorString = `rgba(${r}, ${g}, ${b}, ${a})`;
                onChange(colorString);
            }, presetColors: PRESET_COLORS, disableAlpha: false }) }));
};
export default ColorPallet;
